<template>
    <div class="pc">
        <img src="@/assets/pc/bg.png" alt="" class="bg">
        <img src="@/assets/pc/logo.png" alt="" class="logo">
        <img src="@/assets/pc/video.png" alt="" class="play">
        <img src="@/assets/pc/qr.png" alt="" class="qr">
        <div class="download-wrapper">
            <a href="https://apk-cdn.jinkejoy.com/tom/Tompark/Tompark.apk" target="_blank"><img src="@/assets/pc/android.png" alt="" class="android"></a>
            <img src="@/assets/pc/ios.png" alt="" class="ios">
        </div>
        <!-- <div class="link-wrapper">
            <a href="http://ttf-cdn.jinkejoy.com/privacy.html" target="_blank">隐私协议</a>
            <a href="http://ttf-cdn.jinkejoy.com/eula.html" target="_blank">用户协议</a>
            <a href="https://docs.qq.com/doc/DU0ZCZG9La29SV3Bi" target="_blank">游戏须知</a>
            <a href="http://ttf-cdn.jinkejoy.com/childrenPrivacy.html" target="_blank">儿童协议</a>
        </div> -->
        <footer>
            <div class="footer-inner">
                <img src="@/assets/pc/footer_logo.png" alt="" class="footer-logo">
                <div class="vertical"></div>
                <div class="copyright">
                    <div class="links">
                        <a href="http://jinkejoy.com/article?type=1" target="_blank">用户协议</a>
                        <a href="http://jinkejoy.com/article?type=2" target="_blank">防沉迷系统</a>
                        <a href="http://jinkejoy.com/article?type=3" target="_blank">交易纠纷处理</a>
                        <a href="http://jinkejoy.com/home/parentcare?type=3" target="_blank">家长监护工程</a>
                    </div>
                    <p>健康游戏公告：抵制不良游戏，拒绝盗版游戏，注意自我保护，谨防受骗上单。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
                    <p class="img">
                        <img src="@/assets/pc/gongan.png" alt="">
                        <span>&nbsp;粤公网安备 44010602005837号 &nbsp; | &nbsp; 粤ICP备17075408号-1</span>
                    </p>
                    <p class="img">
                        <img src="@/assets/pc/icp.png" alt="">
                        <span>&nbsp;粤网文〔2017〕7759-1867号</span>
                    </p>
                    <p>联系电话：400-020-9800 &nbsp; | &nbsp; 地址：广州市天河区车陂路113号东宏国际广场10层</p>
                    <p>Copyright &copy; 2010-2021 jinkejoy.com All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="stylus" scoped>
.pc
    position relative
    overflow hidden

    .bg
        width 100%
        height 100%

    .logo
        position absolute
        right -1.5rem
        top 0rem
        width 7.14rem
        height 4rem
    
    .qr
        position absolute
        left .54rem
        top 2.82rem
        width 1.66rem
        height 5.14rem

    .play
        position absolute
        right 3.46rem
        top 2.2rem
        width 1.36rem
        height 1.36rem
        cursor pointer
    
    .download-wrapper
        position absolute
        top 6.48rem
        right 3.89rem
        
        img 
            width 3.7rem
            height 1.4rem
            cursor pointer

    .link-wrapper
        position absolute
        bottom 3rem
        right 4rem

        a
            text-decoration none 
            color #000
            font-weight bold
            font-size .3rem
            margin-right .5rem

    footer 
        padding .2rem 0
        background #272a2c
        color #fff
        margin-top -4px

        .footer-inner
            display: flex;
            align-items: center;
            max-width: 10.24rem;
            text-align: left;
            margin: 0 auto;
            padding: .1rem 0 .1rem;
            font-size: .12rem;
            line-height: 20px;

        .footer-logo
            width 1.28rem
            height .43rem

        .vertical
            width 1px
            height .55rem
            background rgba(255, 255, 255, .3)
            margin 0 .4rem

        .copyright
            .links
                a
                    color #fff
                    margin-right .05rem

            .img
                display flex
                align-items center
</style>